/** @jsx jsx */

import { connect } from 'react-redux';
import { css, jsx } from '@emotion/core';
import { updateUserPaletteAction } from 'actions/updateUserPaletteAction';
import { colors } from 'styles/variables';
import AddRemoveBtn from 'components/UI/AddRemoveBtn';
import getStore from 'services/getStore';
import { themeButtonDefault } from 'store/store';

const store = getStore();

const { lPink, lGrey0 } = colors;

const Swatch = ({ color, onClick }) => {
  return (
    <div
      css={css`
        flex-shrink: 0;
      `}
      style={{
        width: 20,
        height: 20,
        marginRight: 5,
        border: `1px solid ${
          ['#fff', '#ffffff', '#FFF', '#FFFFFF', '', undefined, null].includes(
            color
          )
            ? '#ff0063'
            : color
        }`,
        borderRadius: '50%',
        background: color,
        cursor: 'pointer',
      }}
      onClick={onClick}
    />
  );
};

const AddRemoveBtnWrapped = ({ rotation = 0, onClick }) => {
  return (
    <div
      css={css`
        margin-right: 5px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      `}
    >
      <AddRemoveBtn
        color={lPink}
        rotation={rotation}
        size={20}
        onClick={onClick}
      />
    </div>
  );
};

const UserPalette = ({
  currentColor,
  selectColor,
  theme,
}: {
  currentColor?: string;
  selectColor?: any;
  theme?: any;
}) => {
  const {
    headerBackgroundColor = '#fff',
    headerTextColor = lGrey0,
    backgroundColor = '#fff',
    textColor = lGrey0,
    buttonBackgroundColor = lPink,
    buttonTextColor = '#fff',
  } = theme;

  const colorsFromTheme = {
    headerBackgroundColor,
    headerTextColor,
    backgroundColor,
    textColor,
    buttonBackgroundColor,
    buttonTextColor,
  };

  //
  // updating from the new theme.buttons.main etc
  const themeButtonsMain = {
    ...themeButtonDefault,
    ...theme?.buttons?.main,
  };

  colorsFromTheme.buttonBackgroundColor = themeButtonsMain.backgroundColor;
  colorsFromTheme.buttonTextColor = themeButtonsMain.textColor;
  //
  //

  let userPalette: string[] = [];
  if (theme?.userPalette && Array.isArray(theme.userPalette)) {
    userPalette = Array.from(theme.userPalette) as string[];
  }

  const addToPalette = () => {
    if (currentColor && userPalette.includes(currentColor)) {
      return;
    }

    store.dispatch(updateUserPaletteAction([...userPalette, currentColor]));
  };

  const removeFromPalette = () => {
    const confirm = window.confirm('Remove this color from your palette?');
    if (!confirm) return;

    store.dispatch(
      updateUserPaletteAction([...userPalette.filter(c => c !== currentColor)])
    );
  };

  return (
    <div>
      <h4 style={{ marginBottom: 5, fontSize: 14 }}>Colours from theme:</h4>
      <div
        css={css`
          display: flex;
          flexwrap: wrap;
        `}
      >
        {Object.keys(colorsFromTheme).map((color, i) => (
          <Swatch
            key={color}
            color={colorsFromTheme[color]}
            onClick={() => selectColor(colorsFromTheme[color])}
          />
        ))}
      </div>

      <h4 style={{ margin: '15px 0 5px 0', fontSize: 14 }}>
        Add or remove current colour:
      </h4>

      <div
        css={css`
          display: flex;
        `}
      >
        <AddRemoveBtnWrapped rotation={45} onClick={addToPalette} />
        <AddRemoveBtnWrapped rotation={0} onClick={removeFromPalette} />
      </div>
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
        `}
      >
        {userPalette.map((color, i) => (
          <Swatch
            key={color + i}
            color={color}
            onClick={() => selectColor(color)}
          />
        ))}
      </div>
    </div>
  );
};

export default connect(({ theme }: { theme: any }) => ({
  theme,
}))(UserPalette);
